import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import cdn from 'lib/cdn'
import Head from 'next/head'

function MetaData(): JSX.Element {
  const metaTitle =
    'Wholesale Marketplace - Pusat Grosir Online Indonesia'
  const metaDescription =
    'Ralali.com, Pusat toko grosir online pertama di Indonesia, sebagai b2b wholesale marketplace platform yang menghubungkan supplier, distributor dengan retail.'
  return (
    <Head>
      {process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION_CODE && (
        <meta
          name="facebook-domain-verification"
          content={
            process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION_CODE
          }
        />
      )}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta
        name="keywords"
        content="wholesale marketplace, pusat grosir, grosir online, grosir indonesia"
      />
      <meta
        name="author"
        content="Ralali B2B Marketplace Indonesia"
      />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={WEB_DESKTOP_RALALI_URL} />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content={cdn({ path: '/og_image_default.png' })}
      />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Ralali",
            "url": "${WEB_DESKTOP_RALALI_URL}", 
            "sameAs": [
              "https://www.facebook.com/ralalicom",
              "https://twitter.com/ralalicom",
              "https://www.youtube.com/channel/UCA7tGuG-avOIEzcL97ybZqQ",
              "https://www.linkedin.com/company/ralali-com",
              "https://www.instagram.com/ralalicom"
            ],
            "logo": "${cdn({ path: '/logo-ralali.png' })}"
          }`,
        }}
      />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Ralali",
            "alternateName": "Ralali.com",
            "url": "${WEB_DESKTOP_RALALI_URL}",
            "description": "Pusat Toko Grosir Online Indonesia"
          }`,
        }}
      />
    </Head>
  )
}

export default MetaData
